module.exports = _.head;